import { Configuration, PublicClientApplication } from "@azure/msal-browser";

/**
 * Configuración de MSAL — apunta al App Registration REAL
 * (`cfe-review-api-app-registration`, appId=5c2b9478-1d72-4f82-bd59-a19cbbdf7267),
 * confirmado en docs/Decisions.md del backend (04-05/08/2026). No son valores
 * de ejemplo, son los reales — ver .env.example.
 *
 * ⚠️ GAP CONOCIDO (ver CLAUDE.md, "Gap conocido: auth de la SPA"): para que
 * esto funcione de verdad, el App Registration necesita tener registrada la
 * plataforma "Single-page application" con el redirect URI real de este
 * Frontend (hoy solo tiene el redirect URI del propio backend, para su
 * login vía Easy Auth — no el de esta SPA). Sin ese paso, el login de MSAL
 * va a fallar con AADSTS9002326 ("Cross-origin token redemption is
 * permitted only for the 'Single-Page Application' client-type") o similar.
 * No se puede cerrar ese paso hasta tener la URL real de la SWA desplegada.
 */

const clientId = import.meta.env.VITE_AAD_CLIENT_ID as string;
const tenantId = import.meta.env.VITE_AAD_TENANT_ID as string;
const redirectUri = (import.meta.env.VITE_AAD_REDIRECT_URI as string) || window.location.origin;

if (!clientId || !tenantId) {
  // Fail-fast intencional: es mejor un error claro en consola al arrancar
  // que un fallo silencioso de MSAL más adelante.
  // eslint-disable-next-line no-console
  console.error(
    "Faltan VITE_AAD_CLIENT_ID / VITE_AAD_TENANT_ID — copiar .env.example a .env.local y completar."
  );
}

export const msalConfig: Configuration = {
  auth: {
    clientId,
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri,
    postLogoutRedirectUri: redirectUri,
  },
  cache: {
    // localStorage (no sessionStorage) — para que la sesión sobreviva un
    // refresh de página, comportamiento esperado en una SPA de uso diario.
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
};

/**
 * Scope real de la API (ver .env.example) — SIN este scope exacto,
 * acquireTokenSilent/Popup fallan con AADSTS650057 "Invalid resource"
 * (confirmado por la sesión que trabajó en el backend, ver Decisions.md).
 */
export const apiScopes: string[] = [import.meta.env.VITE_API_SCOPE as string];

export const msalInstance = new PublicClientApplication(msalConfig);
